import { useContext } from "react";
import { OpenClosedContext, openClosedContext } from "./openClosedContext";

export const useOpenClosed = (): OpenClosedContext => {
  return useContext(openClosedContext);
}